<template>
	<tr class="d-flex pl-2" :id="value">
		<td class="py-1 pl-2 item">{{ name }}</td>
		<td
			:class="wrapFlag ? 'py-1 pl-2 value pre-wrap' : 'py-1 pl-2 value'"
			v-if="
				column.data_type == 'integer' ||
				column.data_type == 'string' ||
				column.data_type == 'float' ||
				column.data_type == 'option' ||
				column.data_type == 'target' ||
				column.data_type == 'date' ||
				column.data_type == 'boolean' ||
				column.data_type == 'feature'
			"
		>
			{{ value }}
		</td>
		<td class="py-1 pl-2 value" v-if="column.data_type == 'text'">
			<p class="pre-wrap">{{ value }}</p>
		</td>
		<td :class="wrapFlag ? 'py-1 pl-2 value' : 'py-1 pl-2 value'" v-if="column.data_type == ''">
			<p class="pre-wrap">{{ value }}</p>
		</td>
		<td
			v-if="column.data_type == 'synchronization'"
			:class="wrapFlag ? 'py-1 pl-2 value pre-wrap' : 'py-1 pl-2 value'"
		>
			<template v-if="typeof value === 'object'">
				<RubberProcessShowDialog
					v-if="column.data_synchronization.reflect_model == 'RubberProcess'"
					:id="synchronizationModelId()"
					:is_draft="!!value.synchronized_datum"
					:showEditBtn="false"
					requiredDialogBtn
				>
					<template v-slot:open-btn="{ openDialog }">
						<a @click="openDialog">
							{{ common.value(column, value) }}
						</a>
					</template>
				</RubberProcessShowDialog>
			</template>
			<template v-else>
				{{ value }}
			</template>
		</td>

		<td
			:class="wrapFlag ? 'py-1 pl-2 value pre-wrap' : 'py-1 pl-2 value'"
			v-if="column.data_type == 'url'"
		>
			<a :href="value" target="_blank">{{ value }}</a>
		</td>

		<td
			:class="wrapFlag ? 'py-1 pl-2 value pre-wrap' : 'py-1 pl-2 value'"
			v-if="column.data_type == 'file'"
		>
			<v-row no-gutters class="pa-2" v-for="(file, index) in value" :key="'file-' + index">
				<v-icon>mdi-file-upload-outline</v-icon>
				{{ file.name }}
			</v-row>
		</td>
		<td v-if="fullCheckFLag" class="py-1 check">
			<v-checkbox
				hide-details="false"
				v-model="checkbox"
				@change="changeCheckbox()"
				label="確認"
			></v-checkbox>
		</td>
	</tr>
</template>

<script>
import moment from "moment/min/moment.min.js"
import common from "../../../helper/common"

export default {
	props: {
		name: {
			type: String,
			required: false,
			default: "",
		},
		value: {
			required: false,
			default: "",
		},
		fullCheckFLag: {
			type: Boolean,
			required: true,
			default: "",
		},
		column: {
			type: Object,
			required: true,
			default: {},
		},
		wrapFlag: {
			type: Boolean,
			required: true,
			default: false,
		},
	},
	components: {
		RubberProcessShowDialog: () =>
			import("../../rubber_process/components/RubberProcessShowDialog.vue"),
	},
	data() {
		return {
			checkbox: false,
			common: common,
		}
	},
	filters: {
		toMoment(date) {
			return moment(date).format("YYYY/MM/DD")
		},
	},
	mounted() {
		this.$emit("childAddMaxCounter")
	},
	methods: {
		byMoment(date) {
			return moment(date).format("YYYY/MM/DD")
		},
		changeCheckbox() {
			if (this.checkbox) {
				this.$emit("childChecked")
			} else {
				this.$emit("childNotChecked")
			}
		},
		synchronizationModelId() {
			return this.value.synchronized_datum?.id || this.value.model?.id
		},
	},
}
</script>

<style lang="scss" scoped>
th,
td {
	border-left: solid gray 1px;
	&:first-child {
		border-left: none;
	}
}
tr {
	border-bottom: solid gray 1px;
}
td.item {
	width: 20%;
}
td.value {
	width: 60%;
}
td.check {
	width: 20%;
}
td td {
	white-space: pre-wrap;
}

.matter-record {
	td {
		line-height: 1.2;
		padding: 0.25rem 1rem;
		.matter-product-record {
			&:not(:first-child) {
				border-top: 1px solid whitesmoke;
			}
			td {
				padding: 0.25rem 0;
				border: none;
			}
		}
	}
}

.point-cell {
	margin-bottom: 0;
	word-break: break-all;
	white-space: pre-wrap;
}
.v-messages.theme--light {
	display: none;
}
.v-input--selection-controls {
	margin-top: 0 !important;
}
.pre-wrap {
	white-space: pre-wrap;
}
</style>
